export default [
  {
    path: '/apps/tipo-pedido-estabelecimento/list',
    name: 'apps/tipo-pedido-estabelecimento/list',
    component: () => import('@/views/cadastros-gerais/tipo-pedido-estab/list/Index.vue'),
    meta: {
      pageTitle: 'Tipo Pedido X Estabelecimento',
      resource: 'AdminHanes',
    },
  },
];
